import { ParticipantMarketType, ParticipantType } from '@cds/betting-offer';

import { BetslipV2ParticipantPick } from '../../../../../core/picks/betslip-v2-participant-pick';
import { ParticipantPickType } from '../../../../../core/picks/pick-models';
import { isRacePick } from '../../../../picks/services/betslip-pick-helpers';
import { BaseComboPrevention } from './combo-prevention';
import { ComboPreventionResult } from './combo-prevention-result.enum';

/**
 * Validates V2 participant picks for combo.
 */
export class V2ParticipantComboPrevention extends BaseComboPrevention<BetslipV2ParticipantPick, BetslipV2ParticipantPick> {
    constructor() {
        super(BetslipV2ParticipantPick, BetslipV2ParticipantPick);
    }

    validate(thisPick: BetslipV2ParticipantPick, otherPick: BetslipV2ParticipantPick, isSystemBet: boolean): ComboPreventionResult {
        if (thisPick.market.marketType === ParticipantMarketType.Tricast) {
            // Tricast is not combinable.
            return ComboPreventionResult.RaceTricast;
        }
        if (thisPick.market.marketType === ParticipantMarketType.Forecast && otherPick.market.marketType !== ParticipantMarketType.Forecast) {
            // Forecast pick can be combinable only with other forecast picks.
            return ComboPreventionResult.OnlyRaceForecast;
        }

        if (this.isExcludedParticipantType(thisPick, otherPick)) {
            // Can not combine picks with same participant.
            return ComboPreventionResult.SameRaceParticipant;
        }

        if (isSystemBet && isRacePick(thisPick) && thisPick.id.pickType === ParticipantPickType.CombinationForecast) {
            return ComboPreventionResult.SystemCombinationForecast;
        }

        if (thisPick.fixture.fixtureId === otherPick.fixture.fixtureId) {
            return ComboPreventionResult.SameFixture;
        }

        return ComboPreventionResult.AllCombo;
    }

    private isExcludedParticipantType(thisPick: BetslipV2ParticipantPick, otherPick: BetslipV2ParticipantPick): boolean {
        const isNotExcludedParticipantType = (type: ParticipantType) => ![ParticipantType.Favourite, ParticipantType.Trap].includes(type);

        return thisPick.participants.some(
            (tp) =>
                isNotExcludedParticipantType(tp.type) &&
                otherPick.participants.some((op) => isNotExcludedParticipantType(op.type) && tp.participantId === op.participantId),
        );
    }
}
